<div
  class="eventq-input"
  [class.eventq-input--label-overlay]="!!label() && labelPosition() === 'overlay'"
  [class.eventq-input--label-above]="!!label() && labelPosition() === 'above'"
>
  @if (label() && labelPosition() === 'above') {
    <label class="eventq-input__label" [attr.for]="inputId">
      {{ label() }}
      @if (requiredIndicator()) {
        <span class="eventq-input__required" aria-hidden="true">*</span>
      }
    </label>
  }
  <div
    class="eventq-input__field"
    [class.eventq-input__field--invalid]="showValidationError()"
    [class.eventq-input__field--multiline]="multiline()"
  >
    @if (label() && labelPosition() === 'overlay') {
      <label class="eventq-input__label" [attr.for]="inputId">
        {{ label() }}
        @if (requiredIndicator()) {
          <span class="eventq-input__required" aria-hidden="true">*</span>
        }
      </label>
    }
    @if (multiline()) {
      <textarea
        [id]="inputId"
        class="eventq-input__control eventq-input__control--textarea"
        [placeholder]="placeholder()"
        [rows]="rows()"
        [value]="value()"
        [attr.maxlength]="maxLength()"
        [disabled]="disabled()"
        [attr.aria-invalid]="showValidationError()"
        [attr.aria-describedby]="showValidationError() ? 'eventq-input-error-' + inputId : null"
        (input)="onInput($event)"
        (blur)="onBlur()"
      ></textarea>
    } @else {
      <input
        [id]="inputId"
        class="eventq-input__control"
        [class.eventq-input__control--masked]="passwordMasked()"
        [type]="resolvedType()"
        [placeholder]="placeholder()"
        [value]="displayValue()"
        [attr.maxlength]="maxLength()"
        [disabled]="disabled()"
        [attr.autocomplete]="inputAutocomplete()"
        [attr.spellcheck]="type() === 'password' ? false : null"
        [attr.aria-invalid]="showValidationError()"
        [attr.aria-describedby]="showValidationError() ? 'eventq-input-error-' + inputId : null"
        (beforeinput)="onBeforeInput($event)"
        (input)="onInput($event)"
        (blur)="onBlur()"
      />
      @if (showPasswordToggle() && type() === 'password') {
        <button
          type="button"
          class="eventq-input__toggle"
          aria-label="Toggle password visibility"
          [disabled]="disabled()"
          (click)="togglePasswordVisibility()"
        >
          <mat-icon>{{ passwordVisible() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      }
    }
  </div>
  @if (showValidationError()) {
    <p class="eventq-input__error" [id]="'eventq-input-error-' + inputId">{{ validationMessage() }}</p>
  }
</div>
